/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckAIcon16Solid = forwardRef('CheckAIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M15.205 3.064a1.5 1.5 0 0 1 0 2.122l-6.832 6.832a3.088 3.088 0 0 1-4.367 0L1.47 9.481a1.5 1.5 0 0 1 2.12-2.12l2.538 2.536c.034.034.09.034.123 0l6.833-6.833a1.5 1.5 0 0 1 2.121 0Z" })));
});
